import React from "react";
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import URL from "../../../../constant/URL";
import http from "../../../../http/http";
import {withRouter} from "react-router-dom";
import lottie from "lottie-web";
import useLoading from "../../../../hooks/useLoading";
import useSound from "../../../../hooks/useSound";
import A from "../../../common/A";
import { errorMessage } from "../../../../redux/errorState";
import { useUserInfo } from "../../../../hooks";


const LevelComplete = withRouter((props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const { setLoading, clearLoading } = useLoading();
  const { setSound, playSound } = useSound();
  const [fadeClass, setFadeClass] = React.useState('num');
  const [flag] = React.useState(true);

  const renderAnimation = () => {

    let url = '';
    let id = '';

    if(flag){
      url = `${ process.env.PUBLIC_URL }/static/json/img_lc_03_03_01.json`;
      id = 'ani2';
    }else{
      url = `${ process.env.PUBLIC_URL }/static/json/img_lc_03_03_02.json`;
      id = 'ani3';
    }

    let data = {
      container: document.getElementById(id),
      path : url,
      renderer: 'svg',
      loop: false,
      autoplay: true,
    };
   let anim =  lottie.loadAnimation(data);
    anim.addEventListener('DOMLoaded', (e)=>{
      playSound();
      clearLoading();
    })
  };

  const renderChange = () => {
    setTimeout(()=>{
      // setFlag(false);
      setFadeClass('num fade');
    }, 2000);
  };


  const courseComplete = () => {
    if (!props.nextLevelCode) {
      dispatch(errorMessage('msg', t("LC_03_02.msg007")));
      return;
    }

    onLoading();
    http.request({
      url: `${URL.API.LEARNING.COURSE}/level/history/member/${info.learnerId}/level/${props.level}`,
      method: http.METHOD.POST,
      data:{
        lrnMbrId: info.learnerId,
        lvlCd : props.level
      },
      success: (res) => {
        clearLoading();
        props.history.replace({
          pathname: URL.COURSE_LEARNING.COMPLETE_LOADING,
        });
      },
      error: (err) => {
        if (err) {
          clearLoading();
        }
      }
    });
  };

  const onLoading = () => {
    setLoading({ isShowSpinner:true, spinnerType:'2' });
    setSound({src : `${ process.env.PUBLIC_URL }/static/audio/lc_03_03_balloon.ogg`});
  };

  React.useEffect(onLoading, []);
  React.useEffect(renderChange, [props?.levelNm, props?.result]);
  React.useEffect(renderAnimation, [flag]);

  return (
    <>
    <div className="lev_box">
      <div className="box">LEVEL {props?.levelNm}</div>
    </div>
    <div className="score_wrap">
      <div className="bg_img">
        <article>
          <div className="tit">{t("LC_03_03.msg005")}</div>
          <div className="num">{props.result?.lpsc02Cnt}</div>
        </article>
        <article className="area_enough">
          <div className="tit">{t("LC_03_03.msg006")}</div>
          <div className="num">{props.result?.lpsc03Cnt}</div>
        </article>
        <article className="area_great">
          <div className="tit">{t("LC_03_03.msg007")}</div>
          <div className="num">{props.result?.lpsc04Cnt}</div>
        </article>
        <div className="anim-wrap" id="ani2"></div>
      </div>
    </div>
    <div className="box_wrap">
      <div className="box">
        <div className="tit">{t("LC_03_03.msg008")}</div>
        <div className={fadeClass}>
          <span>{t("LC_03_03.msg010")}</span><span className="total">{props.result?.cransrQstCtTotalCnt}</span><span>{t("LC_03_03.msg011")}</span>
        </div>
      </div>
    </div>
    <div className="btns_wrap">
      <A className="btn btn-blue" onClick={courseComplete}>{t("LC_03_03.msg009")}</A>
    </div>
    </>
  );

});

export default LevelComplete;


